import { getVariantCapability, isFiloOlympicVariant, isSmallOlympicVariant } from '../config/variant-profile';

export { isSmallOlympicVariant };

export const SCIENTIFIC_SUPERVISOR_CATEGORY = 'Opiekun naukowy';
export const SCHOOL_SCIENTIFIC_CATEGORY = 'Opiekun szkolno-naukowy';

export type TeacherCategoryOption = {
	teacher: string;
	scientificSupervisor: string;
	schoolScientific?: string;
	noSchoolFacilityLabel: string;
};

export function getTeacherCategoryOptions(): TeacherCategoryOption {
	const labels = getVariantCapability('teacher.categoryLabels');
	if (isFiloOlympicVariant() || getVariantCapability('registration.guardianRolesSplit')) {
		return {
			teacher: labels.teacher,
			scientificSupervisor: labels.scientific_supervisor,
			schoolScientific: labels.school_scientific || SCHOOL_SCIENTIFIC_CATEGORY,
			noSchoolFacilityLabel: 'Opiekun naukowy bez szkoły (np. uczelnia, korepetytor) — wybierz okręg uczniów poniżej',
		};
	}
	if (isSmallOlympicVariant()) {
		return {
			teacher: labels.teacher,
			scientificSupervisor: labels.scientific_supervisor,
			noSchoolFacilityLabel:
				'Opiekun spoza szkoły podstawowej (np. korepetytor, liceum, uczelnia) — wybierz okręg uczniów poniżej',
		};
	}
	return {
		teacher: labels.teacher,
		scientificSupervisor: labels.scientific_supervisor,
		noSchoolFacilityLabel:
			'Opiekun spoza szkoły ponadpodstawowej (np. korepetytor, podstawówka, uczelnia) — wybierz okręg uczniów poniżej',
	};
}

export function isScientificSupervisorCategory(category: string, options = getTeacherCategoryOptions()): boolean {
	return (
		category === options.scientificSupervisor ||
		category === SCIENTIFIC_SUPERVISOR_CATEGORY ||
		category === options.schoolScientific ||
		category === SCHOOL_SCIENTIFIC_CATEGORY
	);
}

/** Naukowy bez szkoły — tylko czysty „Opiekun naukowy”, nie szkolno-naukowy. */
export function isScientificOnlyCategory(category: string, options = getTeacherCategoryOptions()): boolean {
	return category === options.scientificSupervisor || category === SCIENTIFIC_SUPERVISOR_CATEGORY;
}

export function isSchoolScientificCategory(category: string, options = getTeacherCategoryOptions()): boolean {
	return category === options.schoolScientific || category === SCHOOL_SCIENTIFIC_CATEGORY;
}

/** Kategorie w dropdownie. */
export function getTeacherCategoryDropdownValues(): string[] {
	const o = getTeacherCategoryOptions();
	if (o.schoolScientific) {
		return [o.teacher, o.scientificSupervisor, o.schoolScientific];
	}
	return [o.teacher, o.scientificSupervisor];
}

/** Czy po wyborze kategorii domyślnie zaznaczyć „bez szkoły” (filo: Opiekun naukowy). */
export function categoryImpliesNoSchool(category: string): boolean {
	return isScientificOnlyCategory(category);
}

/**
 * Checkbox „bez szkoły”:
 * - OLiJP / OLiJP-SP: zawsze (jak dotychczas),
 * - filo: tylko przy kategorii „Opiekun naukowy” (nie szkolny / szkolno-naukowy).
 */
export function showNoSchoolFacilityCheckbox(category: string): boolean {
	if (!getVariantCapability('registration.guardianRolesSplit')) {
		return true;
	}
	return isScientificOnlyCategory(category);
}
